module.exports = __webpack_public_path__ + "img/cover1.276e3e3a.png";